module.exports = __webpack_public_path__ + "static/2 kl.-10033cd81522987761b372e543e0a5a6.jpg";